export default __webpack_public_path__ + "static/media/Medium's Tunic of Supreme Decree.fbe22c96.jpg";